document.addEventListener('DOMContentLoaded', function () {
    var swiperMain = new Swiper('.swiper_main', {
        loop: true,
        slidesPerView: 1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        on: {
            slideChange: function () {
                let currentSlide = this.slides[this.activeIndex];
                let mainSlider = currentSlide.querySelector('.main-slider');
                if (mainSlider) {
                    let menuName = mainSlider.dataset.navTitle;
                    let headerNav = document.querySelector('.header__primary-nav');
                    let targetNav = headerNav.querySelector(`.header__primary-nav-item[data-title=${menuName}]`);
                    if (targetNav) {
                        headerNav.querySelector(`.header__primary-nav-item.active`).classList.remove('active');
                        targetNav.classList.add('active');
                    }
                    setTimeout(function () {
                        headerNav.querySelectorAll('.header__primary-nav-item').forEach(function (Element) {
                            if (Element.classList.contains('active')) {
                                sessionStorage.setItem('nav-title', Element.getAttribute('data-title'));
                            }
                        });
                    }, 500);
                }
            },
        },
    });

    let interleaveOffset = 0.95;
    let swiper = new Swiper('.main-slider .swiper-container', {
        direction: 'vertical',
        loop: false,
        speed: 900,
        mousewheelControl: true,
        watchSlidesProgress: true,
        mousewheel: {
            releaseOnEdges: true,
        },
        touchReleaseOnEdges: true,
        autoplay: {
            delay: 6000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: '.main-slider .swiper-button-next',
            prevEl: '.main-slider .swiper-button-prev',
        },
        pagination: {
            el: '.main-slider .swiper-pagination',
            clickable: true,
            type: 'bullets',
            renderBullet: function (index, className) {
                if (index < 9) {
                    return '<span class="' + className + '">' + '0' + (index + 1) + '</span>';
                } else {
                    return '<span class="' + className + '">' + (index + 1) + '</span>';
                }
            },
        },
        on: {
            progress: function () {
                let swiper = this;

                for (let i = 0; i < swiper.slides.length; i++) {
                    let slideProgress = swiper.slides[i].progress;
                    let innerOffset = swiper.height * interleaveOffset;
                    let innerTranslate = slideProgress * innerOffset;

                    let innerElement = swiper.slides[i].querySelector('.main-slider__inner');
                    if (innerElement) {
                        TweenMax.set(innerElement, {
                            y: innerTranslate,
                        });
                    }
                }
            },
            setTransition: function (slider, speed) {
                let swiper = this;

                for (let i = 0; i < swiper.slides.length; i++) {
                    let slide = swiper.slides[i];
                    slide.style.transition = speed + 'ms';

                    let innerElement = slide.querySelector('.main-slider__inner');
                    if (innerElement) {
                        innerElement.style.transition = speed + 'ms';
                    }
                }
            },
            init: function () {
                // Reproducir el video de la primera diapositiva activa
                let activeSlide = this.slides[this.activeIndex];
                if (activeSlide) {
                    let video = activeSlide.querySelector('.swiper-video');
                    if (video) {
                        video.play();
                    }
                }
            },
            slideChangeTransitionStart: function () {
                // Pausar todos los videos al cambiar de diapositiva
                this.slides.forEach(slide => {
                    let video = slide.querySelector('.swiper-video');
                    if (video) {
                        video.pause();
                    }
                });
            },
            slideChangeTransitionEnd: function () {
                // Reproducir el video de la diapositiva activa
                let activeSlide = this.slides[this.activeIndex];
                if (activeSlide) {
                    let video = activeSlide.querySelector('.swiper-video');
                    if (video) {
                        video.play();
                    }
                }
            },
        },
    });

    function wheel(event) {
        var delta = 0;
        if (!event) event = window.event;
        if (event.wheelDelta) {
            delta = event.wheelDelta / 120;
        } else if (event.detail) {
            delta = -event.detail / 3;
        }
        if (delta) {
            if (delta > 0) {
                if (swiper.mousewheel) {
                    swiper.mousewheel.enable();
                }
            }
        }
    }

    window.addEventListener('mousewheel', wheel);
    window.addEventListener('DOMMouseScroll', wheel);
});
